var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHeart = function SvgHeart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.43 0c-2.11 0-3.982.833-5.25 2.264C10.91.833 9.04 0 6.93 0A6.94 6.94 0 0 0 0 6.93c0 7.595 11.11 13.664 11.582 13.92a1.26 1.26 0 0 0 1.195 0c.473-.256 11.582-6.325 11.582-13.92A6.94 6.94 0 0 0 17.43 0m-.577 14.947a34.5 34.5 0 0 1-4.673 3.34 34.5 34.5 0 0 1-4.674-3.34C5.231 12.996 2.52 10.02 2.52 6.93a4.41 4.41 0 0 1 4.41-4.41c1.869 0 3.433.987 4.083 2.577a1.26 1.26 0 0 0 2.333 0c.65-1.59 2.215-2.577 4.084-2.577a4.41 4.41 0 0 1 4.41 4.41c0 3.089-2.712 6.066-4.987 8.017"
  })));
};
export default SvgHeart;